import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ScoringType } from '../../../types'

import { initialState } from './model'

const scoring = createSlice({
  name: 'scoring',
  initialState,
  reducers: {
    setDenialReason: (state, { payload }: PayloadAction<string>) => {
      state.denialReason = payload
    },
    startScoring: (_state, _action: PayloadAction<ScoringType>) => {},
    startScoringLoop: (_state, _action: PayloadAction<ScoringType>) => {},
  },
})

export const scoringActions = scoring.actions

export default scoring.reducer
